import {
	customCrashesStore,
	UPLOADED_CRASHES_LAYER_ID
} from '#lib/stores/customCrashesStore.svelte.js';
import { legendStore } from '#lib/stores/legendStore.svelte.js';

// The uploaded-crash overlay is always a registered legend layer, so its active-legend
// row would otherwise show before any upload; hide it until crash data exists.
export function activeLegendLayers() {
	return customCrashesStore.data?.features.length
		? legendStore.layers
		: legendStore.layers.filter((l) => l.systemId !== UPLOADED_CRASHES_LAYER_ID);
}
